
// Property types available in the system
export const propertyTypes = [
  "Building",
  "Office Floor",
  "Co Working", 
  "Restaurant", 
  "In a Complex / Mall",
  "Hotels", 
  "Multipurpose",
  "Commercial House", 
  "Showroom / Shop", 
  "Commercial Land",
  "Beachfront Land",
  "Agricultural Land"
] as const;

// Feature options for properties
export const propertyFeatures = [
  "Central AC",
  "Internet",
  "24 Hours Security",
  "Backup Generator",
  "Fire Detection",
  "Lifts",
  "On-site parking",
  "Staff Parking",
  "Staff Accommodation",
  "Backup Power",
  "Solar Power",
  "Service Entrance",
  "Elevator",
  "Grade A Facilities",
  "Fibre Internet",
  "3 Phase Electricity"
];

// Furnishing options
export const furnishingOptions = [
  "Furnished",
  "Partly Furnished",
  "Unfurnished"
];

// Status options for properties
export const statusOptions = [
  "Available Now",
  "Available Soon",
  "Price Reduced",
  "Offer Received",
  "Rented",
  "Sold"
];

// Price period options
export const pricePeriodOptions = [
  "Per Month",
  "Per Year",
  "Total Price"
];

// Currency options
export const currencyOptions = [
  "LKR",
  "USD",
  "EUR",
  "GBP"
];

// Districts in Sri Lanka
export const sriLankaDistricts = [
  "Colombo",
  "Gampaha",
  "Kalutara",
  "Kandy",
  "Matale",
  "Nuwara Eliya",
  "Galle",
  "Matara",
  "Hambantota",
  "Jaffna",
  "Kilinochchi",
  "Mannar",
  "Vavuniya",
  "Mullaitivu",
  "Batticaloa",
  "Ampara",
  "Trincomalee",
  "Kurunegala",
  "Puttalam",
  "Anuradhapura",
  "Polonnaruwa",
  "Badulla",
  "Monaragala",
  "Ratnapura",
  "Kegalle"
];

// Map from API property types to display names
export const propertyTypeDisplayNames: Record<string, string> = {
  "Office": "Office Space",
  "Commercial Building": "Commercial Building",
  "Warehouse": "Warehouse/Storage",
  "Land": "Commercial Land",
  "Restaurant": "Restaurant/Cafe",
  "Commercial House": "Commercial House",
  "Multipurpose Building": "Multipurpose Building",
};

// Map from API listing types to display names
export const listingTypeDisplayNames: Record<string, string> = {
  "Sale": "For Sale",
  "Rent": "For Rent",
  "Lease": "For Lease",
};
